import { styled } from "styled-components"

const Partner = () => {
  return(
    <Container>
      <img src = {"/imgs/home/partner.png"} alt="partner" />
    </Container>
  )
}


export default Partner


const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height:583px;
  background: #0A1120;
  img{
    width:989px;
    height:181px;
  }
`